import { Column, ModelBase } from 'loca-boot-core'
import { ResourceItemModel } from '../iconRender/icon.model'

export class TagItemModel extends ModelBase {
  @Column()
  public icon!: string
  @Column()
  public text!: string
  @Column()
  public type!: string
  @Column()
  public backgroundColor!: string
  @Column()
  public fontColor!: string
}

export class NewStationItemModel extends ResourceItemModel {
  @Column({ name: 'tag_list_new', childType: TagItemModel, autowired: true })
  public tagList!: TagItemModel[]
  @Column({ name: 'hints', childType: TagItemModel, autowired: true })
  public hints!: TagItemModel[]
  @Column({ name: 'crow_flight_distance' })
  public crowFlightDistance!: number
  @Column({ name: 'crow_flight_distance_desc' })
  public crowFlightDistanceDesc!: number
}

export class NewStationListModel extends ModelBase {
  @Column({ name: 'resources', childType: NewStationItemModel, autowired: true })
  public resources!: NewStationItemModel[]
}

// 时间维度筛选配置
export class TimeDimItem extends ModelBase {
  @Column()
  public timeDimCode!: string

  @Column()
  public timeDimDesc!: string
}
export class TimeDimList extends ModelBase {
  @Column({ childType: TimeDimItem, autowired: true })
  public timeDims!: TimeDimItem[]
}
